
import { defineComponent, PropType } from 'vue'
import { Analyzer } from '~/types/types'
import Ticker from '../Common/Ticker.vue'

export default defineComponent({
  name: 'StatCard',
  components: {
    Ticker
  },
  props: {
    icon: {
      type: [String, Object] as PropType<string | Analyzer>
    },
    value: {
      type: String
    },
    title: {
      type: String
    },
    trendValue: {
      type: [Number, String],
      default: null
    },
    trendIcon: {
      type: String,
      default: null
    },
    trendDirection: {
      type: String,
      default: null
    },
    trendHint: {
      type: String,
      default: null
    },
    trendPositive: {
      type: Boolean,
      default: null
    },
    removeStyles: {
      type: Boolean,
      default: false
    },
    to: {
      type: String,
      default: null
    },
    hintAsTooltip: {
      type: Boolean,
      default: true
    },
    withTransition: {
      type: Boolean,
      default: false
    },
    isPassing: {
      type: Boolean,
      default: null
    },
    threshold: {
      type: Number,
      default: null
    },
    valueTextSize: {
      type: String,
      default: 'text-1.5xl',
      validator: (val: string) => val.startsWith('text-')
    }
  },
  computed: {
    color(): string {
      return this.isPassing === false ? 'cherry' : 'juniper'
    },
    thresholdLabel(): string {
      return `${this.isPassing ? 'Above' : 'Below'} ${
        this.threshold !== null ? `${this.threshold}%` : 'threshold'
      }`
    }
  },
  methods: {
    isIconShortcode(icon: string | Analyzer): icon is string {
      return typeof icon === 'string'
    }
  }
})
